import React from "react"

const debug: boolean = false
// const debug: string = "SelectGenericValueNotEmpty"

export default function SelectGenericValueNotEmpty(props:any) {

    debug && console.log(debug, "render", props)

    const classes: string = Classes(props.valueClasses, props.className)

    let valueComponent
    if (props.option.color) {
        const valueClasses: string = Classes('ui5-pillbox s26 w200', 'gd-c-bgp-'+props.option.color, 'gd-c-pale-border-'+props.option.color)
        valueComponent = <div className={valueClasses}>{props.option.label}</div>
    } else {
        valueComponent = <div className="ui5-txt-default txt-truncate">{props.option.label}</div>
    }

    return (
        <React.Fragment>
            <div className={classes} onClick={props.onClick}>
                {valueComponent}
            </div>
            {props.children}
        </React.Fragment>
    )
}

SelectGenericValueNotEmpty.defaultProps = {
    valueClasses: "ui5-field-form-editable dropdown-form h-36"
}